__webpack_require__.p = "/Stoic-Quote-Generator/";